import { postJSON } from 'common/services/api'
import { useMutation, useQueryClient } from 'react-query'
import type { AdministrationStatus } from '../types'
import { MAR_CHART_QUERY_KEY, STOCK_LOGS_QUERY_KEY } from './queryConstants'

type UseUpdateAdministrationRecordProps = {
  onSuccess?: () => void
  onError?: (error: any) => void
}

type UpdateAdministrationRecordRequest = {
  administrationStatus: AdministrationStatus
  note?: string | null
}

export const useUpdateAdministrationRecord = ({
  onSuccess,
  onError
}: UseUpdateAdministrationRecordProps = {}) => {
  const queryClient = useQueryClient()

  const mutation = useMutation(
    ({
      recordId,
      data
    }: {
      recordId: string
      data: UpdateAdministrationRecordRequest
    }) => {
      return postJSON({
        url: `/emar/medication-administration-instances/${recordId}`,
        method: 'PUT',
        json: data
      })
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([STOCK_LOGS_QUERY_KEY])
        queryClient.invalidateQueries([MAR_CHART_QUERY_KEY])
        onSuccess?.()
      },
      onError: (error) => {
        console.error('Error updating administration record:', error)
        onError?.(error)
      }
    }
  )

  return {
    updateAdministrationRecord: mutation.mutateAsync,
    isLoading: mutation.isLoading
  }
}
